import React, { useState } from "react";
import styles from "./Product.module.sass";
import cn from "classnames";
import Details from "./Details";


const Product = ({ documentData, isProspect = false }) => {
  // Afficher les données du document pour débogage
  console.log('Document dans Product:', documentData);
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClose = () => {
    setActiveIndex(0);
    setVisible(false);
  };

  return (
    <div className={cn(styles.product, { [styles.active]: visible })}>
      <Details
        className={styles.details}
        setValue={setVisible}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        documentData={documentData}
        isProspect={isProspect}
      />
    </div>
  );
};

export default Product;
